import React from 'react';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';
import { UserProfile } from '../../types';

interface LgpdStepProps {
  formData: UserProfile;
  onConsentChange: (consentData: any) => void;
  onOpenTerms: () => void;
  onOpenPrivacy: () => void;
}

export default function LgpdStep({
  formData,
  onConsentChange,
  onOpenTerms,
  onOpenPrivacy
}: LgpdStepProps) {
  const items = [
    { id: 'termsAccepted', label: 'Li e aceito as regras de uso' },
    { id: 'privacyPolicyAccepted', label: 'Li e concordo com a Política de Privacidade' },
    { id: 'dataProcessingAccepted', label: 'Deixo o sistema usar meus dados para calcular meus lucros' },
    { id: 'marketingAccepted', label: 'Quero receber dicas para vender mais' },
    { id: 'marketDataSharingAccepted', label: 'Quero contribuir anonimamente com os Índices de Preços e Benchmarking da minha região (Art. 12 LGPD)' },
  ];

  return (
    <div className="space-y-6">
      <div className="bg-blue-50 border border-blue-100 rounded-2xl p-4">
        <div className="flex gap-3">
          <ShieldCheck className="h-5 w-5 text-blue-600 shrink-0" />
          <div>
            <h4 className="text-sm font-bold text-blue-900">Seus dados protegidos</h4>
            <p className="text-xs text-blue-700 mt-1 leading-relaxed">
              Respeitamos sua privacidade e cuidamos das suas informações com segurança.
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {items.map((item) => (
          <label key={item.id} className="flex items-start gap-3 cursor-pointer group">
            <div className="relative flex items-center mt-0.5">
              <input
                type="checkbox"
                checked={(formData.lgpdConsent as any)?.[item.id] || false}
                onChange={(e) => {
                  const currentConsent = formData.lgpdConsent || {
                    termsAccepted: false,
                    privacyPolicyAccepted: false,
                    dataProcessingAccepted: false,
                    marketingAccepted: false,
                    timestamp: new Date().toISOString()
                  };
                  onConsentChange({
                    ...currentConsent,
                    [item.id]: e.target.checked,
                    timestamp: new Date().toISOString()
                  });
                }}
                className="peer h-5 w-5 appearance-none rounded-md border-2 border-zinc-200 checked:bg-blue-600 checked:border-blue-600 transition-all"
              />
              <CheckCircle2 className="absolute h-3 w-3 text-white opacity-0 peer-checked:opacity-100 left-1 transition-opacity" />
            </div>
            <span className="text-xs text-zinc-600 leading-tight group-hover:text-zinc-900 transition-colors">
              {item.id === 'termsAccepted' ? (
                <>
                  Li e aceito as{' '}
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onOpenTerms();
                    }}
                    className="text-blue-600 font-bold underline hover:text-blue-800 focus:outline-none"
                  >
                    regras de uso
                  </button>
                </>
              ) : item.id === 'privacyPolicyAccepted' ? (
                <>
                  Li e concordo com a{' '}
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onOpenPrivacy();
                    }}
                    className="text-blue-600 font-bold underline hover:text-blue-800 focus:outline-none"
                  >
                    Política de Privacidade
                  </button>
                </>
              ) : (
                item.label
              )}
            </span>
          </label>
        ))}
      </div>

      <div className="text-[10px] text-zinc-400 leading-relaxed bg-zinc-50 p-4 rounded-xl border border-zinc-100">
        <p className="font-bold mb-1 uppercase tracking-widest">Informação Legal:</p>
        Seus dados estão trancados a sete chaves e seguem a lei. Você pode pedir para apagar tudo quando quiser pelo suporte.
      </div>
    </div>
  );
}
